import { APICore } from './apiCore';

const api = new APICore();

// ─── Input Interfaces ─────────────────────────────────────────────────────────

export interface IBannerInput {
    imageUrl: string;
    actionUrl: string;
    show?: boolean;
}

export interface ISectionItemInput {
    productIds?: string[];
    serviceIds?: number[];
    eventIds?: number[];
    ritualIds?: number[];
    title?: string | null;
    description?: string | null;
    category?: string | null;
    isPremium?: boolean;
    thumbnailUrl?: string | null;
    imageUrl?: string | null;
    rating?: number | null;
    name?: string | null;
    date?: string | null;
    price?: number | null;
    show?: boolean;
}

export interface IDashboardSectionInput {
    sectionName: string;
    uiStyle: 'Festival' | 'Horizontal' | 'Grid' | 'Event';
    show?: boolean;
    sectionList?: ISectionItemInput[];
}

export interface ICreateDashboardPayload {
    createdBy: string;
    updatedBy?: string;
    show?: boolean;
    banners?: IBannerInput[];
    dashboardData?: IDashboardSectionInput[];
}

export interface IUpdateDashboardPayload {
    updatedBy?: string;
    show?: boolean;
    banners?: IBannerInput[];
    dashboardData?: IDashboardSectionInput[];
}

// ─── API Functions ────────────────────────────────────────────────────────────

// GET /dashboard  (latest active dashboard)
// GET /dashboard?customerId=X&poojariId=Y
function getDashboard(params?: { customerId?: number; poojariId?: number }) {
    return api.get('/dashboard', params || {});
}

// GET /dashboard/:id
function getDashboardById(id: number, params?: { customerId?: number; poojariId?: number }) {
    return api.get(`/dashboard/${id}`, params || {});
}

// POST /dashboard/create
function createDashboard(data: ICreateDashboardPayload) {
    return api.create('/dashboard/create', data);
}

// PATCH /dashboard/:id  (full-replace banners/sections if provided)
function updateDashboard(id: number, data: IUpdateDashboardPayload) {
    return api.updatePatch(`/dashboard/${id}`, data);
}

// DELETE /dashboard/:id
function deleteDashboard(id: number) {
    return api.delete(`/dashboard/${id}`);
}

export {
    getDashboard,
    getDashboardById,
    createDashboard,
    updateDashboard,
    deleteDashboard,
};
